<template>
    <div class="office_box" v-loading="loading">
            <div class="offices">
                <div class="title_box">
                    <div class="lefts">
                        <div class="title_text1">推荐事务所</div>
                        <div class="title_text2">REFERRAL FIRM</div>
                        <div class="title_img">
                            <img src="../../assets/img/index/home/right1.png" alt="">
                        </div>
                    </div>
                    <div class="rights">
                        <div class="btns2" @click="handle_lvsuo_add">事务所入驻</div>
                    </div>
                </div>
                <div class="off_list_box">
                    <div class="off_list" v-for="(item, index) in list" :key="index">
                         <div class="item_top">
                            <img src="../../assets/img/index/home/lsuo.png" alt="">
                         </div>
                         <div class="item_bom">
                            <div class="item_title">{{ item.company }}</div>
                            <div class="item_tag">
                                <!-- <div class="tegs">房产债务</div> -->
                                <div class="tegs_text">{{ item.info }}</div>
                            </div>
                            <div class="item_address">
                             <img src="../../assets/img/index/home/address2.png" alt="">
                                {{ minx_get_province(item.province) }}
                            </div>
                         </div>
                        
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            list:[],
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_lvsuo_add(){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.$emit('handle_lvsuo_add')
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list(){
            this.loading=true
            this.$api("lawFirms", {
                limit:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('律所1',res)
                if (res.code == 1) {
                  this.list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
 .office_box {
        width: 100%;
        padding-top: 80px;
        background: #fff;

        .offices {
            width: 1440px;
            // height: 200px;
            // background-color: red;
            padding-bottom: 11px;
            margin: auto;

            .title_box {
              
                display: flex;
                align-items: end;
                // align-content: end;
                justify-content: space-between;
                .lefts{
                    display: flex;
                    align-items: end;
                    .title_text1 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #333333;

                    }

                    .title_text2 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #377CFD;
                        margin-left: 16px;
                    }

                    .title_img {
                        width: 24px;
                        height: 24px;
                        margin-left: 16px;

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .rights{
                    display: flex;
                    align-items: center;
                    .btns1{
                        width: 180px;
                        height: 40px;
                        border-radius: 20px 20px 20px 20px;
                        border: 1px solid #377CFD;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 40px;
                    }
                    .btns2{
                        width: 180px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 20px 20px 20px 20px;
                        line-height: 40px;
                        cursor: pointer;
                        text-align: center;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-left: 16px;
                    }
                }
                
            }

            .off_list_box {
                display: flex;
                align-items: center;
                // flex-wrap: wrap;
                
                justify-content: space-between;
                padding-top: 50px;
                .off_list{
                    width: 453px;
                    min-height: 417px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 40px 1px rgba(55,124,253,0.08);
                    border-radius: 8px 8px 8px 8px;
                    cursor: pointer;
                    .item_top{
                        width: 453px;
                        height: 255px;
                        border-radius: 8px 8px 0px 0px;
                        img{
                            width: 453px;
                            height: 255px;
                            border-radius: 8px 8px 0px 0px;
                        }
                    }
                    .item_bom{
                        padding: 16px 24px;
                        .item_title{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #000B33;
                        }
                        .item_tag{
                            padding-top: 10px;
                            display: flex;
                            align-items: center;
                            padding-bottom: 24px;
                            border-bottom: 1px solid #EDEDED;
                            .tegs{
                                width: 72px;
                                height: 24px;
                                flex-shrink: 0;
                                background: #FDF6EC;
                                border-radius: 3px 3px 3px 3px;
                                border: 1px solid #FFAA00;
                                line-height: 24px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #FFAA00;

                            }
                            .tegs_text{
                                // padding-left: 16px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }

                        }
                        .item_address{
                            padding-top: 18px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;

                            img{
                                width: 18px;
                                // height: 16px;
                                margin-right: 8px;
                            }
                        }
                    }
                    
                }
                 
            }
        }
    }
</style>